export default __webpack_public_path__ + "static/3-6bfaef6d7ca0d660cb6ad2d7b99704ae.jpeg";